<template>
	<h2 type="primary" style="margin-left: 16px" @click="caonima = true">案例中心 声明：图中均为安全审计使用并无非法入侵</h2>
	<!-- <el-button type="primary" style="margin-left: 16px" @click="caonima = true">
	  caonima
	 </el-button> -->
		
	 <el-drawer v-model="caonima" title="傻逼element作者傻逼团队名字起的真精神" :with-header="false">
	   <span>Hi sb变量名不让人改!</span>
			<div>
				
			    <marquee style="color: navy;text-align: left;background-color: darkturquoise;">
			     这是一个elementplus得按钮组件
			      <code v-text="'<el-button>'"></code>
			      其实并不好看
			    </marquee>
				<marquee behavior="" direction="" style="color:red;">123321你是一个大傻逼这会影响你单手开法拉利吗，不只会让你沉迷装逼</marquee>
			    <el-button type="primary">尼玛—傻逼(即你不美vue版button)</el-button>
				<input type="checkbox" name="复选框" />
				<button style="width: 220px;height: 40px;background-color: red;">原生版button</button>
				<input type="button" value="原生版button效果2" style="background-color: blue;width: 220px;height: 40px;color: aliceblue;"/>
				<dl></dl>
				<iframe src="https://www.ninesleeves.online/pingyu.html"></iframe>
				<select style="width: 124px;background-color: aqua;width: 140px;height: 34px;">
					<option value="Vue(element)">Vue(element)</option>
					<option value="原生">原生</option>
				</select>
				<iframe src="https://www.ninesleeves.online/element.html"></iframe>
			  </div>
	 </el-drawer>

	<img src="../assets/101671116274_.pic.jpg"/>
	<img src="../assets/111671116275_.pic.jpg"/>
	<img src="../assets/121671116276_.pic.jpg"/>
	<img src="../assets/131671116276_.pic.jpg"/>
	<img src="../assets/141671116277_.pic.jpg"/>
	<img src="../assets/151671116277_.pic.jpg"/>
	<img src="../assets/161671116278_.pic.jpg"/>
	<img src="../assets/171671116279_.pic.jpg"/>
	<img src="../assets/181671116280_.pic.jpg"/>
	<img src="../assets/201671116281_.pic.jpg"/>
	<img src="../assets/221671116283_.pic.jpg"/>
	<img src="../assets/231671116283_.pic.jpg"/>
	<img src="../assets/231671116283_.pic.jpg"/>
	<img src="../assets/241671116284_.pic.jpg"/>
	<img src="../assets/251671116285_.pic.jpg"/>
	<img src="../assets/261671116286_.pic.jpg"/>
	<img src="../assets/271671116286_.pic.jpg"/>
	<img src="../assets/281671116287_.pic.jpg"/>
	<img src="../assets/291671116288_.pic.jpg"/>
	<img src="../assets/301671116288_.pic.jpg"/>
	<img src="../assets/311671116289_.pic.jpg"/>
	<img src="../assets/321671116290_.pic.jpg"/>
	<img src="../assets/331671116291_.pic.jpg"/>
	<img src="../assets/351671116292_.pic.jpg"/>
	<img src="../assets/371671116293_.pic.jpg"/>
	<img src="../assets/411671116476_.pic.jpg"/>
	<img src="../assets/391671116375_.pic.jpg"/>
	<img src="../assets/421671116554_.pic.jpg"/>

	<h2>仅为部分截图也欢迎各界小伙伴加入我们但这是官网商用得不要讨论这些线下私聊</h2>
</template>

<script setup>
import { ref } from 'vue'
const caonima = ref(false)
</script>

<style>
	
</style>